// extracted by mini-css-extract-plugin
export var reviewContainer = "Reviews-module--reviewContainer--6vF1q";
export var reviewMore = "Reviews-module--reviewMore--Cgpxb";
export var widgetContainer = "Reviews-module--widgetContainer--BmoF7";
export var reviewHeader = "Reviews-module--reviewHeader--AKfU6";
export var reviewTitle = "Reviews-module--reviewTitle--TdrvA";
export var reviewBlockBlury = "Reviews-module--reviewBlockBlury--LSQIY";